module.exports = __webpack_public_path__ + "static/media/logoIphone.265a5efc.png";